/**
 * Default settlement stage from SCARFiled.
 * SCAR is only the default when every selected case has SCARFiled === 1.
 * Master Petition cases that are not SCAR filed default to Art7 (BAR is not used).
 */

import { isMasterPetitionCase } from '../SummaryCaseTable/utils/helpers.js';

export function isScarFiledForSettlement(caseItem) {
  const filed = caseItem?.SCARFiled;
  return filed === 1 || filed === '1';
}

export function resolveSettlementCaseItem(row, negotiationObj) {
  if (!row?.parcel_id) return null;
  const fromStore = negotiationObj?.cases?.find((c) => c.parcel_id === row.parcel_id);
  if (fromStore) return fromStore;
  if ('SCARFiled' in row) return row;
  return null;
}

export function isScarStageAvailableForRows(rows, negotiationObj) {
  if (!rows?.length) return false;
  return rows.every((row) => {
    const caseItem = resolveSettlementCaseItem(row, negotiationObj);
    if (!caseItem) {
      throw new Error('[settlementStage] Missing case object for SCAR filed check.');
    }
    return isScarFiledForSettlement(caseItem);
  });
}

export function getDefaultSettlementStage(rows, negotiationObj) {
  if (isScarStageAvailableForRows(rows, negotiationObj)) return 'SCAR';
  const first = resolveSettlementCaseItem(rows[0], negotiationObj) || rows[0];
  return isMasterPetitionCase(first) ? 'Art7' : 'BAR';
}

export function getSettlementStageForRow(row, negotiationObj) {
  const caseItem = resolveSettlementCaseItem(row, negotiationObj);
  if (!caseItem) {
    throw new Error('[settlementStage] Missing case object for stage resolution.');
  }
  return isScarFiledForSettlement(caseItem) ? 'SCAR' : (isMasterPetitionCase(caseItem) ? 'Art7' : 'BAR');
}

/** Preserve row order; split only where stage changes between consecutive rows. */
export function groupSettledRowsByConsecutiveStage(rows, negotiationObj) {
  const groups = [];
  for (const row of rows) {
    const stage = getSettlementStageForRow(row, negotiationObj);
    const last = groups[groups.length - 1];
    if (last?.stage === stage) {
      last.rows.push(row);
    } else {
      groups.push({ stage, rows: [row] });
    }
  }
  return groups;
}
